module.exports = __webpack_public_path__ + "media/images/9_help-db615d5c85aef18416682c0b5bcd4a9f.jpg";